import { useState, useEffect } from 'react';

import { Shop } from '../../store/shop';
import { SecondaryButton } from '../Buttons/Buttons';

import styles from './AddressPicker.module.scss';

export default function ShopPicker({ setOpenTakeAwayModal }) {
  const [selectedShop, setSelectedShop] = useState([]);

  useEffect(() => {
    const shop$ = Shop.subscribe(setSelectedShop);

    return () => {
      shop$.unsubscribe();
    };
  }, []);

  if (!selectedShop?.takeAwayShop?.address) return null;

  return (
    <section className={styles.section}>
      <h2 className={styles.addressTitle}>ΚΑΤΑΣΤΗΜΑ ΠΑΡΑΛΑΒΗΣ</h2>
      <p className={styles.instructions}>Επίλεξε το κατάστημα από το οποίο θα παραλάβεις τις αγορές σου.</p>
      <div className={styles.addressContainer}>
        <div className={styles.storeInfo}>
          <img src={`/assets/${process.env.appName}/store.png`} className={styles.addressStore} alt="" />
          <div className={styles.addressDetails}>
            <span className={styles.addressType}>{selectedShop?.takeAwayShop.name}</span>
            <span>
              {`${selectedShop?.takeAwayShop.address.street}
              ${selectedShop?.takeAwayShop.address.streetNo},
              ${selectedShop?.takeAwayShop.address.postalCode},
              ${selectedShop?.takeAwayShop.address.city}`}
            </span>
            <span>{selectedShop?.takeAwayShop.phone}</span>
          </div>
        </div>
        <div className={styles.btnContainer}>
          <SecondaryButton onClick={() => setOpenTakeAwayModal(true)}>
            <p className={styles.buttonText}>Αλλαγή Καταστήματος</p>
          </SecondaryButton>
        </div>
      </div>
    </section>
  );
}
